export const FormValidation = {
    email: {
        required: 'Email address cannot be empty.',
        pattern: {
            value: /^[\w\u00E4\u00F6\u00FC\u00C4\u00D6\u00DC\u00DF'\.-]+@[\w.-]+\.[\w]{2,4}$/,
            message: 'Invalid email address format. Allowed format: name@company.domain.',
        },
        maxLength: {
            value: 100,
            message: 'Email address cannot be more than 100 characters.',
        },
    },
    sendEmail: {
        required: 'Email address cannot be empty.',
        pattern: {
            value: /^[\w\u00E4\u00F6\u00FC\u00C4\u00D6\u00DC\u00DF'\.-]+@[\w.-]+\.[\w]{2,4}$/,
            message: 'Please enter a valid email address.',
        },
        maxLength: {
            value: 100,
            message: 'Email address cannot be more than 100 characters.',
        },
    },
    ContactNumber: {
        maxLength: {
            value: 15,
            message: 'Please make sure phone number does not exceed 15 digits.',
        },
        pattern: {
            value: /^(|\d{1,15})$/, // Allows empty or up to 15 digits
            message: 'Please make sure phone number is formatted correctly.',
        },
    },

    phone: {
        pattern: {
            value: /^(0|[1-9][0-9]*)$/,
            message: 'Please make sure phone number is formatted correctly.',
        },
    },
    loginPassword: {
        required: 'Password cannot be empty.',
    },
    registerPassword: {
        required: 'Password cannot be empty.',
        minLength: {
            value: 8,
            message: 'Password cannot be less than 8 characters.',
        },
        maxLength: {
            value: 24,
            message: 'Password cannot be more than 24 characters.',
        },
        pattern: {
            value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~!@#$%^&*(),.+;:?\/]).{0,}$/,
            message:
                "Password must contain one upper case letter, one lower case letter, one digit and one special character out of '~!@#$%^&*(),.+;:?/'",
        },
    },
    userAccountPassword: {
        required: 'Password cannot be empty.',
        minLength: {
            value: 8,
            message: 'Password cannot be less than 8 characters.',
        },
        maxLength: {
            value: 23,
            message: 'Password cannot be more than 24 characters.',
        },
       pattern: {
        value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~!@#$%^&*(),.+;:?/])[A-Za-z\d~!@#$%^&*(),.+;:?/]{8,24}$/,
        message: 
        "Password must contain one upper case letter, one lower case letter, one digit and one special character out of '~!@#$%^&*(),.+;:?/'",
    }       
    },
    confirmPassword: {
        required: 'Confirm password cannot be empty.',
    },
    confirmPasswordUserSettings: {
        required: 'This field is required.',
    },
    ResetconfirmPassword: {
        rule: {
            required: true,
            equalTo: "#password_input",

        },
        message: {
            required: "Confirm password cannot be empty.",
            equalTo: "Your password and confirmation password do not match.",
        }
    },
    first_name: {
        required: 'First name cannot be empty.',
        maxLength: {
            value: 50,
            message: 'First name cannot be more than 50 characters.',
        },
        pattern: {
            value: /^[a-zA-ZÀ-ÿ0-9. ' -]{1,50}$/,
            message:
                "System supports following for First Name: [A-Z] [a-z] [À-ÿ] [0-9] and special characters: . - '",
        },
    },
    last_name: {
        required: 'Last name cannot be empty.',
        maxLength: {
            value: 50,
            message: 'Last name cannot be more than 50 characters.',
        },
        pattern: {
            value: /^[a-zA-ZÀ-ÿ0-9. ' -]{1,50}$/,
            message:
                "System supports following for Last Name: [A-Z] [a-z] [À-ÿ] [0-9] and special characters: . - '",
        },
    },
    fullname: {
        rule: {
            fullnamecheck: true,
        },
        message: {
            required: 'Field connot be empty.',
            fullnamecheck:
                'Fullname connot be more than 80 characters or cannot be smaller than 3 characters.',
        },
    },
    Log4Net: {
        TextBoxTracerLog: {
            required: 'Path cannot be empty.',
            pattern: {
                value: /^(([a-zA-Z]\:)|(\\))(\\{1}|((\\{1})[^\\]([^/:*?<>""|]*))+)$/,
                message: 'Please enter a valid path.',
            },
            minLength: {
                value: 1,
                message: 'Path cannot be shorter than 1 character.',
            },
            maxLength: {
                value: 10000,
                message: 'Path cannot be longer than 10000 characters.',
            },
        },
        TextBoxAppExLog: {
            required: 'Path cannot be empty.',
            pattern: {
                value: /^(([a-zA-Z]\:)|(\\))(\\{1}|((\\{1})[^\\]([^/:*?<>""|]*))+)$/,
                message: 'Please enter a valid path.',
            },
            minLength: {
                value: 1,
                message: 'Path cannot be shorter than 1 character.',
            },
            maxLength: {
                value: 10000,
                message: 'Path cannot be longer than 10000 characters.',
            },
        },
        TextBoxUIExLog: {
            required: 'Path cannot be empty.',
            pattern: {
                value: /^(([a-zA-Z]\:)|(\\))(\\{1}|((\\{1})[^\\]([^/:*?<>""|]*))+)$/,
                message: 'Please enter a valid path.',
            },
            minLength: {
                value: 1,
                message: 'Path cannot be shorter than 1 character.',
            },
            maxLength: {
                value: 10000,
                message: 'Path cannot be longer than 10000 characters.',
            },
        },
        TextBoxDBPerfLog: {
            required: 'Path cannot be empty.',
            pattern: {
                value: /^(([a-zA-Z]\:)|(\\))(\\{1}|((\\{1})[^\\]([^/:*?<>""|]*))+)$/,
                message: 'Please enter a valid path.',
            },
            minLength: {
                value: 1,
                message: 'Path cannot be shorter than 1 character.',
            },
            maxLength: {
                value: 10000,
                message: 'Path cannot be longer than 10000 characters.',
            },
        },
        TextBoxLogFileSize: {
            required: 'Enter valid file size.',
            min: {
                value: 1,
                message: 'Enter valid file size.',
            },
            max: {
                value: 10000,
                message: 'Enter valid file size.',
            },
        },
        TextBoxLogDeleteDays: {
            required: 'Enter valid number of days.',
            min: {
                value: 1,
                message: 'Enter valid number of days.',
            },
            max: {
                value: 365,
                message: 'Enter valid number of days.',
            },
        },
        TextBoxLogCustomDelimiter: {
            required: 'Enter custom delimiter.',
            minLength: {
                value: 1,
                message: 'Delimiter cannot be shorter than 1 character.',
            },
            maxLength: {
                value: 365,
                message: 'Delimiter cannot be longer than 365 characters.',
            },
            pattern: {
                value: /^(?!.*[\&\-\%]).*$/,  // This regex checks for & or - or % anywhere in the string
                message: 'Cannot accept & or - or %.', 
            },
        },
    },

    primary_role: {
        required: 'You must select a role.',
    },
    ContactUsfullName: {
        required: 'Please fill in the full name field.',
        maxLength: {
            value: 80,
            message: 'Full name length should not be greater than 80 characters.',
        },
        minLength: {
            value: 3,
            message: 'Full name length should be at least 3 characters.',
        },
        pattern: {
            value: /^(?!.*(^\s|\s$))/, //Restrict leading or trailing spaces FP-10413
            message: 'Name should not contain leading or trailing spaces.',
        },
        validate: {
            noSpecialCharsAndNumbers: (value: string) => {
                // Check for special characters and numbers only if there's no leading/trailing space
                if (!/^(?!^\s|\s$)([a-zA-ZÀ-ÿ ']+)$/i.test(value)) {
                    return 'Please make sure the full name does not contain special characters and numbers.';
                }
                return true; 
            }
        },
    },
    contactus_message: {
        required: 'Please fill in the description field.',
        maxLength: {
            value: 255,
            message: 'Message length should not be greater than 255 characters.',
        },
        minLength: {
            value: 3,
            message: 'Message length should be at least 3 characters.',
        },
        pattern: {
            value: /^(?!.*(^\s|\s$))/, //Restrict leading or trailing spaces
            message: 'Message should not contain leading or trailing spaces.',
        },
    },
    Contactus_OrganizationName: {
        maxLength: {
            value: 50,
            message: 'Organization name cannot be more than 50 characters.',
        },
        minLength: {
            value: 3,
            message: 'Please make sure organization name is at least 3 characters long.',
        },
    },
    Settings: {
        firstName: {
            required: 'First name cannot be empty.',
            maxLength: {
                value: 25,
                message: 'First name cannot be more than 25 characters.',
            },
            pattern: {
                value: /^[a-zA-ZÀ-ÿ0-9. ' -]{1,50}$/,
                message: "System supports following for First Name: [A-Z] [a-z] [À-ÿ] [0-9] and special characters: . - '",
            },
        },
        lastName: {
            required: 'Last name cannot be empty.',
            maxLength: {
                value: 25,
                message: 'Last name cannot be more than 25 characters.',
            },
            pattern: {
                value: /^[a-zA-ZÀ-ÿ0-9. ' -]{1,50}$/,
                message: "System supports following for Last Name: [A-Z] [a-z] [À-ÿ] [0-9] and special characters: . - '",
            },
        },
        NationalProviderID: {
            required: false,
           
             pattern: {
                value: /^\d{1,10}$/,
                message: " System supports digits only for National Provider ID (up to 10 digits).",
            },
        },
    },
}
